export const options = {
  languages: [
    "Common",
    "Dwarvish",
    "Elvish",
    "Giant",
    "Gnomish",
    "Goblin",
    "Halfling",
    "Orc",
  ],
  skills: [
    "Acrobatics",
    "Animal Handling",
    "Arcana",
    "Athletics",
    "Deception",
    "History",
    "Insight",
    "Intimidation",
    "Investigation",
    "Medicine",
    "Nature",
    "Perception",
    "Performance",
    "Persuasion",
    "Religion",
    "Sleight of Hand",
    "Stealth",
    "Survival",
  ],
  instruments : [
    "Bagpipes",
    "Drum",
    "Dulcimer",
    "Flute",
    "Lute",
    "Lyre",
    "Horn",
    "Pan Flute",
    "Shawm",
    "Viol",
  ],
  artisansTools: [
    "Alchemist's Supplies",
    "Brewer's Supplies",
    "Calligrapher's Supplies",
    "Carpenter's Tools",
    "Cartographer's Tools",
    "Cobbler's Tools",
    "Cook's Utensils",
    "Glassblower's Tools",
    "Jeweler's Tools",
    "Leatherworker's Tools",
    "Mason's Tools",
    "Painter's Supplies",
    "Potter's Tools",
    "Smith's Tools",
    "Tinker's Tools",
    "Weaver's Tools",
    "Woodcarver's Tools",
  ],
  weapons: {
    martial: [
      "Battleaxe",
      "Flail",
      "Glaive",
      "Greataxe",
      "Greatsword",
      "Halberd",
      "Lance",
      "Longsword",
      "Maul",
      "Morningstar",
      "Pike",
      "Rapier",
      "Scimitar",
      "Shortsword",
      "Trident",
      "War Pick",
      "Warhammer",
      "Whip",
      "Blowgun",
      "Hand Crossbow",
      "Heavy Crossbow",
      "Longbow",
      "Net",
    ],
    simpleMelee: [
      "Club",
      "Dagger",
      "Greatclub",
      "Handaxe",
      "Javelin",
      "Light Hammer",
      "Mace",
      "Quarterstaff",
      "Sickle",
      "Spear",
    ],
  },
  spells: {
    Wizard: {
      cantrips: [
        "Acid Splash",
        "Blade Ward",
        "Booming Blade",
        "Chill Touch",
        "Control Flames",
        "Create Bonfire",
        "Dancing Lights",
        "Encode Thoughts",
        "Fire Bolt",
        "Friends",
        "Frostbite",
        "Green-Flame Blade",
        "Gust",
        "Infestation",
        "Light",
        "lightning Lure",
        "Mage Hand",
        "Mending",
        "Message",
        "Mind Silver",
        "Minor Illusion",
        "Mold Earth",
        "Poison Spray",
        "Prestidigitation",
        "Ray of Frost",
        "Sapping Sting",
        "Shape Water",
        "Shocking Grasp",
        "Sword Burst",
        "Thunderclap",
        "Toll the Dead",
        "True Strike",
      ],
      firstLevel: [
        "Absorb Elements",
        "Alarm",
        "Burning Hands",
        "Catapult",
        "Cause Fear",
        "Charm Person",
        "Chromatic Orb",
        "Color Spray",
        "Comprehend Languages",
        "Detect Magic",
        "Disguise Self",
        "Distort Value",
        "Earth Tremor",
        "Expeditious Retreat",
        "False Life",
        "Feather Fall",
        "Find Familiar",
        "Fog Cloud",
        "Frost Fingers",
        "Gift of Alacrity",
        "Grease",
        "Ice Knife",
        "Identify",
        "Illusory Script",
        "Jim's Magic Missile",
        "Jump",
        "Longstrider",
        "Mage Armor",
        "Magic Missile",
        "Magnify Gravity",
        "Protection from Evil and Good",
        "Ray of Sickness",
        "Shield",
        "Silent Image",
        "Silvery Barbs",
        "Sleep",
        "Snare",
        "Tasha's Caustic Brew",
        "Tasha's Hideous Laughter",
        "Tenser's Floating Disk",
        "Thunderwave",
        "Unseen Servent",
        "Witch Bolt",
      ],
    },
    Bard: {
      cantrips: [
        "Blade Ward",
        "Dancing Lights",
        "Friends",
        "Light",
        "Mage Hand",
        "Mending",
        "Message",
        "Minor Illusion",
        "Prestidigitation",
        "Thunderclap",
        "True Strike",
        "Vicious Mockery",
      ],
      firstLevel: [
        "Animal Friendship",
        "Bane",
        "Charm Person",
        "Color Spray",
        "Command",
        "Comprehend Languages",
        "Cure Wounds",
        "Detect Magic",
        "Disguise Self",
        "Dissonant Whispers",
        "Distort Value",
        "Earth Tremor",
        "Faerie Fire",
        "Feather Fall",
        "Guiding Hand",
        "Healing Word",
        "Heroism",
        "Identity",
        "Illusory Script",
        "Longstrider",
        "Silent Image",
        "Silvery Barbs",
        "Sleep",
        "Speak With Animals",
        "Tasha's Hideous Laughter",
        "Thunderwave",
        "Unseen Servant",
      ],
    },
  },
};
